import { useAtomValue, useSetAtom } from "jotai";
import { LinkIcon, LinkToIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { WidgetOptions } from "@/shared/types/widgetOptions";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseLinkButtonProps {
    name: WidgetOptions;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useLinkButton({ name, setActiveSubMenu }: UseLinkButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom(name));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const value = options[0].value as string;

    const handleClick = () => {
        setActiveSubMenu(null);

        const setLinkOptions = setNewOptions({ name, setWidgetMenuOptions });

        applyValue({ options, value, setNewOptions: setLinkOptions });
    };

    const Icon = name === "link" ? LinkIcon : LinkToIcon;

    const isActive = !!value;

    const content = <Icon className={isActive ? styles.svgStrokeActive : ""} />;

    return { content, handleClick, isActive };
}
